import React, {  useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { DataSupportPartnerContext, ShowSupportPartnersContext } from './types';
import { EditPartnerSupportApi } from '../../../redux/partners/partnerApiCalls';
import { useParams } from 'react-router';
import { Timeout, formattedDate } from '../../../functions/functions';
import ShowErrorMsg from '../../../HtmlComponents/ShowErrorMsg';
import ButtonsForm from '../../../HtmlComponents/ButtonsForm';
import InputsSupportPartner from './forms/InputsSupportPartner';

interface props {
  modal: boolean,
  toggle: () => void,
}

const EditSupportAssModal:React.FC<props> = ({ modal, toggle }) => {
  const [amount, setAmount] = useState("")
  const [createdAt, setCreatedAt] = useState(formattedDate(new Date().toString()))

  const [errors, setErrors] = useState<string[]>([])

  const [loading, setLoading] = useState(false)

  const { setShowSuccessMsg, selectedSupportAss } = useContext(ShowSupportPartnersContext)

  useEffect(() => {
    setAmount(selectedSupportAss.amount.toString())
    setCreatedAt(formattedDate(selectedSupportAss.createdAt))
  }, [selectedSupportAss])

  const dispatch:any = useDispatch()

  const { AssId } = useParams()

  const handleSubmit = async (e: any) => {
    e.preventDefault()
    setLoading(true)
    try {
      const response: any = await dispatch(EditPartnerSupportApi(AssId, { amount, createdAt }, selectedSupportAss._id))
        if(response === true) {
          setAmount("")
          setCreatedAt(formattedDate(new Date().toString()))
          setShowSuccessMsg(true)
          setErrors([])
          toggle()
          setTimeout(() => setShowSuccessMsg(false), Timeout)
        } else {
          setErrors(response)
        }
    } finally {
      setLoading(false)
    }
  }

  return (
    <DataSupportPartnerContext.Provider value={{
      amount, setAmount,
      createdAt, setCreatedAt
    }}>      
      {modal && (
        <>
          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div
              className="fixed inset-0 w-full h-full bg-black opacity-40"
              onClick={toggle}
            ></div>
            <div className="flex items-center min-h-screen px-4 py-8">
              <div className="relative w-full max-w-lg p-4 mx-auto bg-white rounded-md shadow-lg">
                <div className="mt-3">
                  {/* Start Modal Body */}
                  <form
                    className="mt-2 sm:ml-4 sm:text-left"
                    onSubmit={handleSubmit}
                    encType='multipart/form-data'
                  >
                    <ShowErrorMsg errors={errors} setErrors={setErrors} />
                    <InputsSupportPartner />
                    <ButtonsForm loading={loading} toggle={toggle} typeBtn='Modifier' />
                  </form>
                  {/* End Modal Body */}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </DataSupportPartnerContext.Provider>
  );
}

export default EditSupportAssModal
